import { render, staticRenderFns } from "./seoTitle.vue?vue&type=template&id=396864ce"
import script from "./seoTitle.vue?vue&type=script&lang=js"
export * from "./seoTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports